export const namespaced = true;

const defaultNotificationModalBody = {
  type: "error", //error, success, warning
  mode: "default", // default, yes-no
  title: "",
  message: "",
  noAction: () => {},
  noActionTitle: "",
  yesAction: () => {},
  yesActionTitle: ""
};

const defaultTransactionalNotificationModalBody = {
  title: "",
  iconType: "transaction-successful", //transaction-successful, balance-enquiry
  transactionObject: {},
  closeAction: () => {}
};

export const state = {
  notifications: [],
  test: "",
  showNotificationModal: false,
  showTransactionalNotificationModal: false,
  notificationModalBody: defaultNotificationModalBody,
  transactionalNotificationModalBody: defaultTransactionalNotificationModalBody
};

let nextId = 1;

export const getters = {};

export const mutations = {
  PUSH(state, notification) {
    state.notifications.push({
      ...notification,
      id: nextId++
    });
    nextId = nextId++;
  },
  DELETE(state, notificationToRemove) {
    // state.notifications = state.notifications.filter(
    //   notification => notification.id !== notificationToRemove
    // );

    for (let i = 0; i < state.notifications.length; i++) {
      if (state.notifications[i].id === notificationToRemove.id) {
        state.notifications.splice(i, 1);
      }
    }
  },

  SHOW_TRANSACTIONAL_NOTIFICATION_MODAL(state) {
    state.showTransactionalNotificationModal = true;
  },
  CLOSE_TRANSACTIONAL_NOTIFICATION_MODAL(state) {
    state.showTransactionalNotificationModal = false;
  },
  SET_TRANSACTIONAL_NOTIFICATION_MODAL_BODY(state, payload) {
    state.transactionalNotificationModalBody = payload;
  },
  RESET_TRANSACTIONAL_NOTIFICATION_MODAL_BODY(state) {
    state.transactionalNotificationModalBody = defaultTransactionalNotificationModalBody;
  },

  SHOW_NOTIFICATION_MODAL(state) {
    state.showNotificationModal = true;
  },
  CLOSE_NOTIFICATION_MODAL(state) {
    state.showNotificationModal = false;
  },
  SET_NOTIFICATION_MODAL_BODY(state, payload) {
    state.notificationModalBody = payload;
  },
  RESET_NOTIFICATION_MODAL_BODY(state) {
    state.notificationModalBody = defaultNotificationModalBody;
  }
};
export const actions = {
  closeTransactionalNotificationModal({ commit }) {
    commit("CLOSE_TRANSACTIONAL_NOTIFICATION_MODAL");
    commit("RESET_TRANSACTIONAL_NOTIFICATION_MODAL_BODY");
  },

  showTransactionalNotificationModal(
    { commit },
    transactionalNotificationModalBody
  ) {
    commit("SHOW_TRANSACTIONAL_NOTIFICATION_MODAL");
    commit(
      "SET_TRANSACTIONAL_NOTIFICATION_MODAL_BODY",
      transactionalNotificationModalBody
    );
  },

  closeNotificationModal({ commit }) {
    commit("CLOSE_NOTIFICATION_MODAL");
    commit("RESET_NOTIFICATION_MODAL_BODY");
  },

  showNotificationModal({ commit }, notificationModalBody) {
    commit("SHOW_NOTIFICATION_MODAL");
    commit("SET_NOTIFICATION_MODAL_BODY", notificationModalBody);
  },

  addNotificationSlide({ commit }, notification) {
    commit("PUSH", notification);
  },
  removeNotificationSlide({ commit }, notificationToRemove) {
    commit("DELETE", notificationToRemove);
  },

  add({ commit }, notification) {
    commit("PUSH", notification);
  },
  remove({ commit }, notificationToRemove) {
    commit("DELETE", notificationToRemove);
  }
};
